export const seo = {
  title: 'Space Moving',
  description: 'Space Moving Landing',
};
